import React from 'react';
import ForecastSalesComponent from './ForecastSalesComponent';
const ForecastSalesForm = ({ formikProps }) => {
    return React.createElement(ForecastSalesComponent, { formikProps: formikProps });
};
export default ForecastSalesForm;
